<div class="row">
  <div [ngClass]="isInIntegratedContext ? 'col-12' : 'col-8'">
    <div class="row">
      <div *ngIf="!isInIntegratedContext" class="col-12">
        <sb-card>
          <div card-fit>
            <sb-comp-cluster-map [clusters]="geoAggregation?.data" [mapHeight]="300" [mapZoom]=""
                                 (minMaxPointsChange)="refreshMap($event)"></sb-comp-cluster-map>
          </div>
        </sb-card>
      </div>
      <div class="col-12">
        <sb-comp-inventory-list (cartAdd)="prepareBuildFilter('cart',$event)"
                                [(playerCull)]="playerCull"
                                [(geoCull)]="geoCull"
                                (refreshData)="refreshMap()" [cartFilter]="cartFilterList"
                                [isInIntegratedContext]="isInIntegratedContext"></sb-comp-inventory-list>
      </div>
    </div>
  </div>
  <div class="col-4" *ngIf="!isInIntegratedContext">
    <app-inventory-cart [isInModalContext]="isInModalContext" [cartFilter]="cartFilterList" [selectedScreens]="screens"
                        (removeFromCart)="removeFromCart($event)"></app-inventory-cart>
  </div>
</div>
